import { render, staticRenderFns } from "./ReservationWaitingList.vue?vue&type=template&id=32c1f302"
import script from "./ReservationWaitingList.vue?vue&type=script&lang=js"
export * from "./ReservationWaitingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports